import { HDate, months } from '@hebcal/core';

const _CONST_MONTH_HEB = ["", "ניסן", "אייר", "סיון", "תמוז", "מנחם-אב", "אלול", "תשרי", "מר-חשון", "כסלו", "טבת", "שבט", "אדר-ראשון", "אדר-שני", "אדר"];
const _CONST_MONTH_HEB_SHORT = ["", "ניסן", "אייר", "סיון", "תמוז", "אב", "אלול", "תשרי", "חשון", "כסלו", "טבת", "שבט", "אדר א'", "אדר ב'", "אדר"];
const _CONST_DAY_HEB = [ "", "א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'", "ח'", "ט'", "י'", "י\"א", "י\"ב", "י\"ג", "י\"ד", "ט\"ו", "ט\"ז", "י\"ז", "י\"ח", "י\"ט", "כ'", "כ\"א", "כ\"ב", "כ\"ג", "כ\"ד", "כ\"ה", "כ\"ו", "כ\"ז", "כ\"ח", "כ\"ט", "ל'"];
const _CONST_WEEKDAY = ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"];

export const HebDateUtil = {
    GetHebrewDateLong: function (hDate) {
		if (hDate.mm === months.ADAR_I && !hDate.isLeapYear())
            return _CONST_DAY_HEB[hDate.dd] + " " + _CONST_MONTH_HEB[hDate.mm+2] + " " + this.Gimatria(hDate.yy);
		return _CONST_DAY_HEB[hDate.dd] + " " + _CONST_MONTH_HEB[hDate.mm] + " " + this.Gimatria(hDate.yy);
	},
	GetHebrewDateShort: function (hDate) {
		if (hDate.mm === months.ADAR_I && !hDate.isLeapYear())
            return _CONST_DAY_HEB[hDate.dd] + " " + _CONST_MONTH_HEB_SHORT[hDate.mm+2];
		return _CONST_DAY_HEB[hDate.dd] + " " + _CONST_MONTH_HEB_SHORT[hDate.mm];
	},




    IsRoshChodesh: function(hDate) {
        return (hDate.dd === 30 || (hDate.dd === 1 && hDate.mm !== months.TISHREI));
    },
    IsTishaBeav: function(hDate) {
		return (
				(hDate.mm === months.AV) && 
				(
					(hDate.dd === 9 && hDate.getDay() !== 6) || 
					(hDate.dd === 10 && hDate.getDay() === 0)
				)
			);
	},
    IsPurim: function(hDate) {
        return (hDate.dd === 14 
        	    && ((hDate.isLeapYear() && hDate.mm === months.ADAR_II) || (!hDate.isLeapYear() && hDate.mm === months.ADAR_I))
        		);
    },
	IsShushanPurim: function(hDate) {
		return (hDate.dd === 15 
				&& ((hDate.isLeapYear() && hDate.mm === months.ADAR_II) || (!hDate.isLeapYear() && hDate.mm === months.ADAR_I))
                );
	},
	IsPurimKatan: function(hDate) {
		return (hDate.isLeapYear() && hDate.mm === months.ADAR_I && (hDate.dd === 14 || hDate.dd === 15 ));
	},
	IsChanukah: function(hDate) 
	{
		if ((hDate.mm === months.KISLEV && hDate.dd >= 25) || (hDate.mm === months.TEVET && hDate.dd <= 2))
			return true;

		return ((hDate.mm === months.TEVET) && (hDate.dd === 3) && (hDate.daysInMonth(months.KISLEV, hDate.yy) === 29));
	},
	IsPesach: function(hDate) {
		return (hDate.mm === months.NISAN && ((hDate.dd >= 15 && hDate.dd <= 21)));
	},
	IsSukkot: function(hDate) {
		return (hDate.mm === months.TISHREI && (hDate.dd >= 15 && hDate.dd <= 22));
	},
	IsAsetYemeyTshuva: function(hDate) {
		return (hDate.mm === months.TISHREI && (hDate.dd >= 1 && hDate.dd <= 10));
	},
	IsMashivHaruach: function(hDate) {
		return !(
				(hDate.mm === months.NISAN && hDate.dd >= 15) ||
				hDate.mm === months.IYYAR || 
				hDate.mm === months.SIVAN || 
				hDate.mm === months.TAMUZ || 
				hDate.mm === months.AV || 
				hDate.mm === months.ELUL || 
				(hDate.mm === months.TISHREI && hDate.dd < 22)
		);
	},
	IsSummer: function(hDate) {
		return (
				(hDate.mm === months.NISAN && hDate.dd >= 15) ||
				hDate.mm === months.IYYAR || 
				hDate.mm === months.SIVAN || 
				hDate.mm === months.TAMUZ ||
				hDate.mm === months.AV || 
				hDate.mm === months.ELUL || 
				hDate.mm === months.TISHREI || 
				(hDate.mm === months.CHESHVAN && hDate.dd < 7)
		);
	},
	IsWinter: function(hDate) {
		return !this.IsSummer(hDate);
	},
	// כמה ימים עברו מהמופע האחרון של dd/mm (היום עצמו = 0)
	DaysSince: function(hDate, dd, mm) {
		let d = new HDate(dd, mm, hDate.yy);
		if (d.abs() > hDate.abs()) d = new HDate(dd, mm, hDate.yy - 1);
		return hDate.abs() - d.abs();
	},
	// האם בתוך 30 יום משינוי נוסח שחל בתאריך dd/mm (להדגשת הנוסח החדש)
	IsNewText: function(hDate, dd, mm) {
		return this.DaysSince(hDate, dd, mm) < 30;
	},
	IsMozaeyYomtov: function(hDate) {
		return (					
			(hDate.mm === months.TISHREI && (hDate.dd === 2 || hDate.dd === 10 || hDate.dd === 15 || hDate.dd === 21)) || 
			(hDate.mm === months.NISAN && (hDate.dd === 15 || hDate.dd === 22)) ||
			(hDate.mm === months.SIVAN && hDate.dd === 6)
		);
	},
	IsOmer: function(hDate) {
		return	(hDate.mm === months.NISAN && hDate.dd >= 16) ||
				(hDate.mm === months.IYYAR) || 
				(hDate.mm === months.SIVAN && hDate.dd <= 5);
	},
	getDayOfOmer: function(hDate) {
		if (! this.IsOmer(hDate))
			return 0;

		if		(hDate.mm === months.NISAN)	return (hDate.dd - 15);
		else if (hDate.mm === months.IYYAR)	return (hDate.dd + 15);
		else if (hDate.mm === months.SIVAN)	return (hDate.dd + 44);

		return 0;
	},
	IsNasi: function(hDate) {
		return (hDate.dd <= 13 && hDate.mm === months.NISAN);
	},
	IsBorkatIlanot: function(hDate) {
		return (hDate.mm === months.NISAN);
	},


	Is10Betevet(hDate) 
	{
		return ((hDate.mm === months.TEVET) && (hDate.dd === 10));
	},
	Is17Betamuz(hDate) 
	{
		return ((hDate.mm === months.TAMUZ) && ((hDate.dd === 17 && hDate.getDay() !== 6) || (hDate.dd === 18 && hDate.getDay() === 0)));
	},
	IsEsterFast(hDate) 
	{
		return ((hDate.mm === months.ADAR_I || hDate.mm === months.ADAR_II) && ((hDate.dd === 13 && hDate.getDay() !== 6) || (hDate.dd === 11 && hDate.getDay() === 4)));
	},
	IsGdaliaFast(hDate)  
	{
		return ((hDate.mm === months.TISHREI) && ((hDate.dd === 3 && hDate.getDay() !== 6) || (hDate.dd === 4 && hDate.getDay() === 0)));
	},
	IsFast: function(hDate) {
		return (this.IsTishaBeav(hDate) || this.Is10Betevet(hDate) || this.Is17Betamuz(hDate) || this.IsEsterFast(hDate) || this.IsGdaliaFast(hDate));
	},
	IsLedavid: function(hDate) {
		return	(hDate.mm === months.AV && hDate.dd === 30) ||
				(hDate.mm === months.ELUL) || 
				(hDate.mm === months.TISHREI && hDate.dd <= 21);
	},



    IsNoTachanun: function(hDate) {
		return (
			(hDate.mm === months.NISAN)
			|| (hDate.mm === months.IYYAR && (hDate.dd === 14 || hDate.dd === 18))
			|| (hDate.mm === months.SIVAN && (hDate.dd >= 1 && hDate.dd <= 12))
			|| (hDate.mm === months.AV && hDate.dd === 15)
			|| (hDate.mm === months.TISHREI && (hDate.dd >= 9 && hDate.dd <= 30))
			|| (hDate.mm === months.SHVAT && hDate.dd === 15)
			|| (hDate.mm === months.KISLEV && (hDate.dd === 9 || hDate.dd === 10))
			|| (hDate.mm === months.KISLEV && (hDate.dd === 19 || hDate.dd === 20))
			|| (hDate.mm === months.TAMUZ && (hDate.dd === 12 || hDate.dd === 13))
			|| ((hDate.mm === months.ADAR_I || hDate.mm === months.ADAR_II) && (hDate.dd >= 14 && hDate.dd <= 15)) 
			|| this.IsTishaBeav(hDate)
			|| this.IsChanukah(hDate)
			|| this.IsRoshChodesh(hDate)
			);
	},
	IsNoMinchaTachanun: function(hDate) {
		return (
			this.IsNoTachanun(hDate) ||
			(hDate.getDay() === 6) ||
			(hDate.mm === months.IYYAR && hDate.dd === 17) ||
			(hDate.mm === months.AV && hDate.dd === 14) ||
			(hDate.mm === months.SHVAT && hDate.dd === 14) ||
			(hDate.mm !== months.ELUL && hDate.dd === 29) ||
			(hDate.mm === months.KISLEV && hDate.dd === 18) ||
			((hDate.mm === months.ADAR_I || hDate.mm === months.ADAR_II) && (hDate.dd >= 13 && hDate.dd <= 15))
		);
	},



	Gimatria: function(number) {
		var achadot = [ "א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט" ];
		var asarot = [ "י", "כ", "ל", "מ", "נ", "ס", "ע", "פ", "צ" ];
		var meot = [ "ק", "ר", "ש", "ת", "תק", "תר", "תש", "תת", "תתק" ];
		var alafim = [ "א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'", "ח'", "ט'" ];

		var o = "";

		for (let i=alafim.length; i>0; i--)
			if (number >= (i * 1000)) {
				number -= (i * 1000);
				o += alafim[i-1];
			}

		for (let i=meot.length; i>0; i--)
			if (number >= (i * 100)) {
				number -= (i * 100);
				o += meot[i-1];
			}


		for (let i=asarot.length; i>0; i--) {
			if (number === 15) return o + "ט\"ו";
			if (number === 16) return o + "ט\"ז";

			if (number >= (i * 10)) {
				number -= (i * 10);
				o += asarot[i-1];
			}
		}

		for (let i=achadot.length; i>0; i--)
			if (number >= (i)) {
				number -= (i);
				o += achadot[i-1];
			}

		return o.substring(0, o.length-1) + "\"" + o.substring(o.length-1);
	},


	GetCondition: function(condition, hDate) {
		return this[condition](hDate);
	},


	GetMonthOrder: function(m) {
//		const momths = [0, NISAN, IYYAR, SIVAN, TAMUZ, AV, ELUL, TISHREI, CHESHVAN, KISLEV, TEVET, SHVAT, ADAR_I, ADAR_II];
		const momths = [0, 8,     9,     10,    11,    12, 13,   1,       2,        3,      4,     5,     6,      7];
		return momths[m];
	},
	GetMonthKey: function(m) {
		const momths = [0, "NISAN", "IYYAR", "SIVAN", "TAMUZ", "AV", "ELUL", "TISHREI", "CHESHVAN", "KISLEV", "TEVET", "SHVAT", "ADAR_I", "ADAR_II"];
		return momths[m];
	}
		
};